export default "__VITE_ASSET__DtsEuV20__"